import { GiftCoupon } from 'components/gifts-table';

export default function MyCoupon() {
  return (
      <div className="d-flex flex-column align-items-center">
          <div className="d-flex justify-content-center align-items-center mb-4">
              <GiftCoupon variant="big" />
          </div>
      </div>

  );
}
